<template>
  <div>
    <div class="contact" v-for="(item, index) in list" :key="'list-us-' + index">
      <div class="title" v-if="item.list.length">
        <img src="@assets/img/contact/contact-title-icon-left.png" />
        <span>World Pavilion</span>
        <img src="@assets/img/contact/contact-title-icon-right.png" />
      </div>
      <div class="content" v-if="item.list.length">
        <div class="contact-wrapper">
          <div
            class="contact-item"
            v-for="(us, i) in item.list"
            :key="'contact-item-' + i"
          >
            <div class="ci-title">{{us.worker}}</div>
            <div class="ci-content">
              <div class="ci-content-brand">{{us.name}} </div>
              <div class="ci-content-txt">Tel：{{us.tel}}</div>
              <div class="ci-content-email">
                <span>Email：</span>
                <p v-html="us.email"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "contact",
  data() {
    return {
      list: []
    };
  },
  components: {},
  computed: {},
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getContactUsForGroupEn: "contactUs/getContactUsForGroupEn"
    }),
    async init() {
      let list = await this.getContactUsForGroupEn();
      if (list && list.length > 0) {
        list.map(c => {
          c.list.map(d => {
            d.email = d.email.replace(/\n/g, "<br/>");
          })
        })
        this.list = list;
      }
      console.log(this.list);
    }
  }
};
</script>

<style scoped lang="scss">
.contact {
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    color: #024c8b;
    margin-bottom: 30px;
    img {
      display: inline-block;
      padding: 0 12px;
    }
  }
  .content {
    background-color: #fff;
    margin-bottom: 30px;
  }
  &-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0 20px;
  }
  &-item {
    width: calc(50% - 30px);
    height: 200px;
    margin-bottom: 40px;
    .ci {
      &-title {
        padding: 20px 0;
        font-size: 18px;
        font-weight: bold;
        color: #024c8b;
        border-bottom: 1px solid #024c8b;
      }
      &-content {
        &-brand {
          padding-top: 20px;
          padding-bottom: 10px;
          font-size: 18px;
          color: #313131;
          font-weight: bold;
        }
        &-txt {
          font-size: 16px;
          color: #4e4e4e;
        }
        &-email {
          font-size: 16px;
          color: #4e4e4e;
          span {
            float: left;
          }
          p {
            float: left;
          }
        }
      }
    }
  }
}
</style>
